
// import React, { useState } from 'react';

// const DetailProduct = () => {
//   const [selectedColor, setSelectedColor] = useState('Gray');
//   const [selectedSize, setSelectedSize] = useState('L');
//   const [quantity, setQuantity] = useState(1);
//   const [selectedImage, setSelectedImage] = useState(0);

//   const colors = ['Gray', 'Black', 'White', 'Blue'];
//   const sizes = ['XS', 'S', 'M', 'L', 'XL'];

//   // Sample product images
//   const productImages = [
//     'https://images.unsplash.com/photo-1552374196-c4e7ffc6e126?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
//     'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
//     'https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
//     'https://themesflat.co/html/modave/images/products/womens/women-6.jpg',
//     'https://themesflat.co/html/modave/images/products/womens/women-7.jpg'
//   ];

//   const handleQuantityChange = (e) => {
//     const value = Math.max(1, parseInt(e.target.value) || 1);
//     setQuantity(value);
//   };

//   const incrementQuantity = () => {
//     setQuantity(prev => prev + 1);
//   };

//   const decrementQuantity = () => {
//     setQuantity(prev => Math.max(1, prev - 1));
//   };

//   return (
//     <div className="container my-5">
//       <div className="row">

//         <div className="col-md-6">
//           <div className="d-flex">

//             <div className="thumbnail-column me-3">
//               {productImages.map((img, index) => (
//                 <div 
//                   key={index}
//                   className={`thumbnail mb-2 ${selectedImage === index ? 'active' : ''}`}
//                   onClick={() => setSelectedImage(index)}
//                   style={{
//                     width: '100px',
//                     height: '93px',
//                     borderRadius: '8px',
//                     overflow: 'hidden',
//                     cursor: 'pointer',
//                     border: selectedImage === index ? '2px solid #000' : '1px solid #ddd',
//                     opacity: selectedImage === index ? 1 : 0.7,
//                     transition: 'all 0.2s ease'
//                   }}
//                 >
//                   <img 
//                     src={img} 
//                     alt={`Thumbnail ${index + 1}`}
//                     style={{ 
//                       width: '100%', 
//                       height: '100%', 
//                       objectFit: 'cover' 
//                     }}
//                   />
//                 </div>
//               ))}
//             </div>

//             {/* Main Image */}
//             <div className="main-image flex-grow-1">
//               <img 
//                 src={productImages[selectedImage]} 
//                 alt="Stretch Strap Top" 
//                 className="img-fluid rounded"
//                 style={{ 
//                   height: '500px', 
//                   width: '100%', 
//                   objectFit: 'cover',
//                   boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
//                 }}
//               />
//             </div>
//           </div>
//         </div>

//         {/* Product Details */}
//         <div className="col-md-6">
//           <h6 className="text-uppercase text-muted">CLOTHING</h6>
//           <h2 className="mb-3">Stretch Strap Top</h2>

//           <div className="d-flex align-items-center mb-3">
//             <div className="text-warning me-2">
//               {'★'.repeat(5)}
//             </div>
//             <span className="text-muted">(134 reviews)</span>
//           </div>

//           <p className="text-muted mb-3">18 sold in last 23 hours</p>

//           <div className="mb-3">
//             <span className="h3 text-danger">$79.99</span>
//             <span className="text-muted text-decoration-line-through ms-2">$99.99</span>
//             <span className="text-success ms-2">$75.99</span>
//           </div>

//           <p className="mb-4">
//             The garments labelled as Committed are products that have been produced using sustainable fibres or processes, reducing their environmental impact.
//           </p>

//           <div className="alert alert-light mb-4">
//             <i className="bi bi-eye me-2"></i> 28 people are viewing this right now
//           </div>

//           <div className="mb-4">
//             <h6 className="mb-3">Color: {selectedColor}</h6>
//             <div className="d-flex gap-2">
//               {colors.map(color => (
//                 <button
//                   key={color}
//                   className={`btn ${selectedColor === color ? 'btn-dark' : 'btn-outline-dark'}`}
//                   onClick={() => setSelectedColor(color)}
//                   style={{ 
//                     borderRadius: '50%', 
//                     width: '40px', 
//                     height: '40px',
//                     backgroundColor: color.toLowerCase(),
//                     color: ['White', 'Gray'].includes(color) ? 'black' : 'white',
//                     border: selectedColor === color ? '2px solid black' : '1px solid #dee2e6'
//                   }}
//                 >
//                   {selectedColor === color ? '✓' : ''}
//                 </button>
//               ))}
//             </div>
//           </div>

//           <div className="mb-4">
//             <div className="d-flex justify-content-between align-items-center mb-2">
//               <h6>Size: {selectedSize}</h6>
//               <a href="#" className="text-decoration-none">Size Guide</a>
//             </div>
//             <div className="d-flex gap-2">
//               {sizes.map(size => (
//                 <button
//                   key={size}
//                   className={`btn ${selectedSize === size ? 'btn-dark' : 'btn-outline-dark'}`}
//                   onClick={() => setSelectedSize(size)}
//                   style={{ minWidth: '40px' }}
//                 >
//                   {size}
//                 </button>
//               ))}
//             </div>
//           </div>

//           <div className="mb-4">
//             <h6 className="mb-2">Quantity:</h6>
//             <div className="d-flex align-items-center">
//               <button 
//                 className="btn btn-outline-secondary"
//                 onClick={decrementQuantity}
//               >
//                 -
//               </button>
//               <input 
//                 type="number" 
//                 className="form-control text-center mx-2" 
//                 style={{ width: '70px' }}
//                 value={quantity}
//                 onChange={handleQuantityChange}
//                 min="1"
//               />
//               <button 
//                 className="btn btn-outline-secondary"
//                 onClick={incrementQuantity}
//               >
//                 +
//               </button>
//             </div>
//           </div>

//           <div className="d-grid gap-2">
//             <button
//               className="btn btn-dark py-3 text-white fs-6 fw-semibold rounded-pill"
//               style={{
//                 height: '56px',
//                 fontSize: '1rem',
//                 fontWeight: '600'
//               }}
//             >
//               ADD TO CART - ${(79.99 * quantity).toFixed(2)}
//             </button>
//             <button
//               className="btn btn-danger py-3 text-white fs-6 fw-semibold rounded-pill small"
//               style={{
//                 height: '56px',
//                 fontSize: '1rem',
//                 fontWeight: '600'
//               }}
//             >
//               BUY IT NOW
//             </button>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .thumbnail:hover {
//           opacity: 1 !important;
//           border-color: #000 !important;
//         }
//         .btn-outline-dark:hover {
//           background-color: #f8f9fa;
//           color: #000;
//         }
//         .thumbnail-column {
//           display: flex;
//           flex-direction: column;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default DetailProduct;


import React, { useEffect, useState } from 'react';
import TodaysPick from '../Todays/TodaysPick';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { addProduct, decreaseQty, increaseQty } from '../../app/features/cart/cartSlice';
import LoginModal from '../Modal/LoginModal';
import Swal from 'sweetalert2';
import QuickViewModal from '../Modal/QuickViewModal';
import { Modal } from 'react-bootstrap';


const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};

const getUserData = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return null;
  try {
    return JSON.parse(userData);
  } catch {
    return null;
  }
};

const DetailProduct = () => {
  const { product_id } = useParams();
  const userData = getUserData();
const loggedInCustomerId = userData?.user?.customer_id || null;

  const [selectedColor, setSelectedColor] = useState('Gray');
  const [selectedSize, setSelectedSize] = useState('L');
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(0);
  const [activeTab, setActiveTab] = useState('description');
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showQuickViewModal, setShowQuickViewModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage2, setSelectedImage2] = useState("");
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);
  const [modalImageUrl, setModalImageUrl] = useState(""); 

  const cartList = useSelector((state) => state.cart.cartList);
 const [policies, setPolicies] = useState([]);


  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const response = await axios.get(
          "https://vantara.datacubeglobal.com/api/return-policies"
        );
        if (response.data.status === "success") {
          setPolicies(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching policies:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPolicies();
  }, []);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await axios.get(`https://vantara.datacubeglobal.com/api/api-products/${product_id}`);


        if (Array.isArray(res.data) && res.data.length > 0) {
           const productData = res.data[0];
        setProduct(productData);
        setReviews(productData.comments || []);
        } else {
          console.error("No product found");
        }
      } catch (err) {
        console.error("Error fetching product:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [product_id]);

  const handleImageClick = (imgUrl) => {
    setModalImageUrl(imgUrl);
    setShowModal(true);
  };

  const productImages = product
    ? [`https:\/\/vantara.datacubeglobal.com\/storage/${product.primary_image}`,
    ...product.images
      .filter(img => img !== product.primary_image)
      .map(img => `https:\/\/vantara.datacubeglobal.com\/storage/${img}`)]
    : [];



  // const handleAddToCart = (product) => {
  //   const token = getAuthToken();
  //   if (!token) {
  //     setShowLoginModal(true); 
  //     return;
  //   }
  //   dispatch(addProduct(product));
  // };

 const handleAddToCart = async (product) => {
  const token = getAuthToken();

 
  if (!token) {
    setShowLoginModal(true);
    return false; 
  }

  try {
    const res = await axios.post(
      "https://vantara.datacubeglobal.com/api/cart",
      {
        product_id: product?.id || product?.product_id,
        quantity: quantity,
        options: "",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.status === "success") {
      dispatch(addProduct({ ...product, quantity }));

      Swal.fire({
        toast: true,
        icon: "success",
        title: "Added to Cart successfully",
        position: "top-end",
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      }).then(() => {
        setShowQuickViewModal(true);
      });

      return true; 
    } else {
      Swal.fire({
        toast: true,
        icon: "info",
        title: res.data.message || "Unable to add to cart",
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
      return false;
    }
  } catch (error) {
    console.error("Error adding to cart:", error);
    Swal.fire({
      toast: true,
      icon: "error",
      title: "Something went wrong!",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
    return false;
  }
};



  return (
    <div className="container my-5">
      <div className="row">

        <div className="col-md-6">



          <div className="d-none d-md-flex flex-column">
            {/* Main Image */}
            <div className="main-image mb-2">
              <img
                src={productImages[selectedImage]}
                className="img-fluid rounded"
                style={{ height: "550px", width: "100%", objectFit: "cover" }}
              />
            </div>

            {/* Thumbnails Row */}
            <div
              className="thumbnail-row d-flex overflow-x-auto"
              style={{
                gap: "10px",
                maxWidth: "100%",
                paddingBottom: "5px",
                scrollbarWidth: "thin",
              }}
            >
              {productImages.map((img, index) => (
                <div
                  key={index}
                  className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                  onClick={() => setSelectedImage(index)}
                  style={{ flex: "0 0 auto" }}
                >
                  <img src={img} alt={`Thumbnail ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>

          {/* Mobile layout - thumbnails below main image */}
          <div className="d-flex flex-column d-md-none">
            {/* Main Image */}
            <div className="main-image mb-3">
              <img
                src={productImages[selectedImage]}
                // alt={product.product_name}
                className="img-fluid rounded"
              />
            </div>

            {/* Thumbnail Row */}
            <div className="thumbnail-row d-flex justify-content-start gap-2 overflow-auto">
              {productImages.map((img, index) => (
                <div
                  key={index}
                  className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                  onClick={() => setSelectedImage(index)}
                >
                  <img
                    src={img}
                    alt={`Thumbnail ${index + 1}`}
                  />
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* Product Details */}
        <div className="col-md-6">
          <h6 className="text-uppercase text-muted fw-semibold">{product?.category}</h6>
          <h2 className="mb-3">{product?.product_name}</h2>
          {/* 
          <div className="d-flex align-items-center mb-3">
            <div className="text-warning me-2">
              {'★'.repeat(5)}
            </div>
            <span className="text-muted">(134 reviews)</span>
          </div> */}

          {/* <p className="text-muted mb-3">18 sold in last 23 hours</p> */}

          <div className="mb-3">
            <span className="h3 fw-bold" style={{ color: "#7c0046" }}>₹&nbsp;{product?.special_price}</span>
            <span className="text-muted text-decoration-line-through ms-2">
    ₹&nbsp;{product?.mrp}
  </span>
  {product?.mrp && product?.special_price && (
    <span  className="ms-2 px-2 py-1 rounded text-white fw-semibold"
    style={{
      backgroundColor: '#e63946', 
      fontSize: '0.8rem',
    }}>
      {`${((product.mrp - product.special_price) / product.mrp * 100).toFixed(0)}% OFF`}
    </span>
  )}
            {/* <span className="text-muted text-decoration-line-through ms-2">$99.99</span>
            <span className="text-success ms-2">$75.99</span> */}
          </div>

          <p className="mb-4" style={{ lineHeight: '1.6', margin: '0.5rem 0', fontSize: '0.9rem' }}>
            {product?.description}
          </p>
          <div className="mb-4 small">
            <h5 className="mb-3">Product Details</h5>
            <ul className="list-group list-group-flush">
              <li className="list-group-item d-flex justify-content-between">
                <span className="">Brand</span>
                <span>{product?.brand || "-"}</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span className="">Unit</span>
                <span>{product?.unit || "-"}</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span className="">Weight</span>
                <span>{product?.weight ? `${product.weight}` : "-"}</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span className="">Size</span>
                <span>{product?.size || "-"}</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span className="">Package Type</span>
                <span>{product?.package_type || "-"}</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span className="">HSN Code</span>
                <span>{product?.hsn_code || "-"}</span>
              </li>

            </ul>
          </div>



        <div className="mb-4">
  <h6 className="mb-2 fw-bold">Quantity</h6>
  <div className="d-flex justify-content-center d-md-block">
    <div
      className="d-flex align-items-center border rounded-pill overflow-hidden"
      style={{ width: "130px", height: "40px" }}
    >
   
    <button
  type="button"
  className="flex-shrink-0 fw-bold"
  style={{
    width: "40px",
    height: "100%",
    fontSize: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontWeight: "bold",
     transition: "background-color 0.2s",
    backgroundColor: "transparent",
    border: "none",
  }}
  onClick={() => {
    dispatch(decreaseQty(product));
    setQuantity((prev) => Math.max(1, prev - 1));
  }}
     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#d3d3d3"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
>
  -
</button>


      
      <input
        type="number"
        className="form-control text-center border-0 bg-transparent fw-bold"
        style={{
          width: "50px",
          height: "100%",
          fontSize: "16px",
          padding: "0",
          textAlign: "center",
          outline: "none",
          fontWeight: "bold",
        }}
        value={quantity}
        min="1"
        readOnly
      />

     
      <button
        className="flex-shrink-0 fw-bold"
        style={{
          width: "40px",
          height: "100%",
          fontSize: "18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          fontWeight: "bold",
          backgroundColor: "transparent",
          border: "none",
          transition: "background-color 0.2s",
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#d3d3d3"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
        onClick={() => {
          dispatch(increaseQty(product));
          setQuantity((prev) => prev + 1);
        }}
      >
        +
      </button>
    </div>
  </div>
</div>

          <div className=" d-none d-md-block">
            <div className="d-grid gap-2 ">
              {/* <button
              className="btn btn-dark py-3 text-white fs-6 fw-semibold rounded-pill"
            onClick={() => handleAddToCart(product)}
            >
              ADD TO CART - Rs.{((parseFloat(product?.mrp) || 0) * quantity).toFixed(2)}

            </button>

            <button
              className="btn btn-danger py-3 text-white fs-6 fw-semibold rounded-pill small"
            >
              BUY IT NOW
            </button> */}
              <div className="d-grid gap-2">
  {product?.stock === 0 ? (
    <button
      className="btn py-3 fs-6 fw-semibold rounded-pill"
      style={{
        backgroundColor: "#6c757d",
        color: "#fff",
        cursor: "not-allowed",
      }}
      disabled
    >
      OUT OF STOCK
    </button>
  ) : (
    <>
      <button
        className="btn py-3 fs-6 fw-semibold rounded-pill"
        style={{
          backgroundColor: "#7c0046",
          color: "#fff",
        }}
        onClick={() => handleAddToCart(product)}
      >
        ADD TO CART &nbsp;₹&nbsp;
        {((parseFloat(product?.special_price) || 0) * quantity).toFixed(2)}
      </button>

      <button
        className="btn py-3 text-white fs-6 fw-semibold rounded-pill small"
        onClick={async () => {
    const added = await handleAddToCart(product);
    if (added) {
      navigate("/checkout");
    }
  }}
        style={{
          backgroundColor: "#124f14",
          color: "#fff",
        }}
      >
        BUY IT NOW
      </button>
    </>
  )}
</div>

            </div>
          </div>
         <div
  className="d-md-none d-block fixed-bottom bg-white shadow-sm p-3"
  style={{ zIndex: 1030 }}
>
  <div className="container">
    <div className="d-grid gap-2">
      {product?.stock === 0 ? (
        <button
          className="btn py-3 fs-6 fw-semibold rounded-pill"
          style={{
            backgroundColor: "#6c757d",
            color: "#fff",
            cursor: "not-allowed",
          }}
          disabled
        >
          OUT OF STOCK
        </button>
      ) : (
        <>
          <button
            className="btn py-3 fs-6 fw-semibold rounded-pill"
            style={{
              backgroundColor: "#7c0046",
              color: "#fff",
            }}
            onClick={() => handleAddToCart(product)}
          >
            ADD TO CART - ₹
            {((parseFloat(product?.mrp) || 0) * quantity).toFixed(2)}
          </button>

          <button
            className="btn py-3 text-white fs-6 fw-semibold rounded-pill small"
            onClick={async () => {
    const added = await handleAddToCart(product);
    if (added) {
      navigate("/checkout");
    }
  }}
            style={{
              backgroundColor: "#1C3F1D",
              color: "#fff",
            }}
          >
            BUY IT NOW
          </button>
        </>
      )}
    </div>
  </div>
</div>



        </div>
      </div>

      <div className="row mt-5">
        <div className="col-12">
          {/* Horizontal Scrolling Tabs for Mobile */}
          <ul
            className="nav nav-tabs d-flex overflow-x-auto mb-0"
            id="productTabs"
            role="tablist"
            style={{
              gap: '0',
              padding: '0',
              margin: '0',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              WebkitOverflowScrolling: 'touch',
              flexWrap: 'nowrap'
            }}
          >
            <li className="nav-item flex-shrink-0" role="presentation">
              <button
                className={`nav-link small ${activeTab === 'description' ? 'active' : ''}`}
                onClick={() => setActiveTab('description')}
                style={{ padding: '0.5rem 1rem' }}
              >
                Description
              </button>
            </li>
            <li className="nav-item flex-shrink-0" role="presentation">
              <button
                className={`nav-link small ${activeTab === 'reviews' ? 'active' : ''}`}
                onClick={() => setActiveTab('reviews')}
                style={{ padding: '0.5rem 1rem' }}
              >
             Customer Reviews ({reviews?.length || 0})

              </button>
            </li>
            <li className="nav-item flex-shrink-0" role="presentation">
              <button
                className={`nav-link small ${activeTab === 'policies' ? 'active' : ''}`}
                onClick={() => setActiveTab('policies')}
                style={{ padding: '0.5rem 1rem' }}
              >
                Return Policies
              </button>
            </li>
          </ul>


          <div
            className="tab-content p-3 border border-top-0 rounded-bottom bg-white overflow-auto"
            style={{
              maxHeight: '80vh',
              minHeight: '300px',
              fontSize: '0.875rem',
              lineHeight: '1.9',
              marginTop: '0.5rem'
            }}
          >
            {activeTab === 'description' && (
              <div className="tab-pane fade show active">

                <h6 className="mt-0 mb-3 text-uppercase fw-bold">HEALTH BENEFITS&nbsp;&nbsp;:&nbsp;&nbsp;{product?.product_name}</h6>
                <p className="mb-3" style={{ lineHeight: '1.6', margin: '0.5rem 0', fontSize: '1rem' }}>
                  {product?.health_benefit}
                </p>
                <div className="d-flex flex-wrap gap-3 mb-4 desc-thumbnails">
                  {product?.Description_images?.map((img, index) => {
                    const imgUrl = `${product?.image_path}/${img}`;
                    // console.log("Description Image:", imgUrl); 
                    return (
                      <div key={index} className="desc-image">
                        <img
                          src={imgUrl}
                          onClick={() => handleImageClick(imgUrl)}
                          alt={`Health Benefit ${index + 1}`}
                          className="img-fluid rounded shadow-sm"
                          style={{
                            width: '200px',      
                            height: '160px',   
                            objectFit: 'cover',  
                            borderRadius: '12px',
                            transition: 'transform 0.3s ease',
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
                <ul className="list-unstyled mb-3" style={{ lineHeight: '1.7' }}>
                  <li style={{ marginBottom: '0.6rem' }}>•&nbsp;Brand&nbsp;:&nbsp;&nbsp;{product?.brand}</li>
                  <li style={{ marginBottom: '0.6rem' }}>•&nbsp;Size&nbsp;:&nbsp;&nbsp;{product?.size}</li>
                  <li style={{ marginBottom: '0.6rem' }}>•&nbsp;Package&nbsp;:&nbsp;&nbsp;{product?.package_type}</li>
                  <li style={{ marginBottom: '0.6rem' }}>•&nbsp;HSN Code&nbsp;:&nbsp;&nbsp;{product?.hsn_code}</li>
                </ul>

              </div>
            )}

          {activeTab === 'reviews' && (
  <div className="tab-pane fade show active">
    <h5 className="mb-3">Customer Reviews</h5>

    {reviews.length === 0 && <p className="small text-muted">No reviews yet.</p>}

    {reviews.map((review) => (
      <div key={review.comment_id} className="border-bottom pb-3 mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-1">
              {review.customer?.customer_id === loggedInCustomerId
          ? "You"
          : `${review.customer?.first_name || "Anonymous"} ${review.customer?.last_name || ""}`}
          </h6>
          <span className="text-muted small">
            {new Date(review.created_at).toLocaleDateString()}
          </span>
        </div>
        <div className="text-warning mb-2 small">
          {'★'.repeat(review.rating)}
        </div>
     <p className="mb-0 small" style={{ fontSize: "16px" }}>
  {review.comment}
</p>

      </div>
    ))}

    {reviews.length > 5 && (
      <button className="btn btn-outline-dark btn-sm">Load More Reviews</button>
    )}
  </div>
)}

            {activeTab === 'policies' && (
              <div className="tab-pane fade show active">
                 {loading ? (
        <p>Loading policies...</p>
      ) : (
        policies.map((policy) => (
          <div key={policy.policy_id} className="mb-4">
            <h6 className="mt-3 mb-2">{policy.title}</h6>
            <p style={{ whiteSpace: "pre-line" }}>{policy.conditions}</p>
            <p className="small text-muted">
              Return Days: {policy.return_days} | Type: {policy.return_type.replace("_", " ")}
            </p>
            <hr className="my-3" />
          </div>
        ))
      )}
            
              </div>
            )}
          </div>
        </div>
        <LoginModal
          show={showLoginModal}
          handleClose={() => setShowLoginModal(false)}
          handleLoginSuccess={(data) => {
            sessionStorage.setItem("userData", JSON.stringify(data)); // save token
            setShowLoginModal(false);

            dispatch(addProduct(product));
          }}
        />
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="lg"
        >
          <Modal.Body className="text-center p-0">
            {modalImageUrl ? (
      <img
        src={modalImageUrl}
        alt="Product Description"
        className="img-fluid rounded"
        style={{
          maxHeight: "80vh",
          objectFit: "contain",
          width: "100%",
        }}
      />
    ) : (
      <p className="text-muted p-3">Image not available</p>
    )}
          </Modal.Body>
        </Modal>
        <QuickViewModal
          show={showQuickViewModal}
          onHide={() => setShowQuickViewModal(false)}
        />
     
        <hr />
      </div>
      <style jsx>{`
        .thumbnail {
          width: 100px;
          height: 130px;
          border-radius: 8px;
          overflow: hidden;
          cursor: pointer;
          border: 1px solid #ddd;
          opacity: 0.7;
          transition: all 0.2s ease;
        }
        
        .thumbnail.active {
          border: 2px solid #000;
          opacity: 1;
        }
        
        .thumbnail:hover {
          opacity: 1;
          border-color: #000;
        }
        
        .thumbnail img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .thumbnail-column {
          display: flex;
          flex-direction: column;
        }
        
        .thumbnail-row {
          overflow-x: auto;
          padding-bottom: 10px;
        }
        
        .main-image img {
          height: 550px;
          width: 100%;
          object-fit: cover;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }
        
        .nav-tabs .nav-link {
          color: #495057;
          font-weight: 500;
        }
        
        .nav-tabs .nav-link.active {
          color: #dc3545;
          border-bottom: 3px solid #dc3545;
          font-weight: 600;
        }
        
        @media (max-width: 767.98px) {
          .thumbnail {
            width: 70px;
            height: 70px;
            flex-shrink: 0;
          }
          
          .main-image img {
            height: 400px;
          }
          
          .nav-tabs .nav-item {
            flex: 1;
            text-align: center;
          }
        }
        
        .btn-outline-dark:hover {
          background-color: #f8f9fa;
          color: #000;
        }
          /* Horizontal scroll on mobile */
@media (max-width: 767.98px) {
  .desc-thumbnails {
    flex-wrap: nowrap !important; /* prevent wrapping */
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* smooth scroll on iOS */
  }

  .desc-thumbnails .desc-image {
    flex: 0 0 auto; /* keep thumbnails in a row */
  }

  .desc-thumbnails img {
    width: 120px;
    height: 120px;
  }
}

      `}</style>
      <div>
          <TodaysPick />
      </div>
       
    </div>
  );
};

export default DetailProduct;